module.exports = __webpack_public_path__ + "public/images/performance.b3bb1a923b5f90ab68912d466450f0e1.png";